const columnsDefaultStyles = [
  {
    name: 'minWidth',
    value: '10px'
  },
  {
    name: 'width',
    value: '10%'
  },
  {
    name: 'minHeight',
    value: '100px'
  },
  {
    name: 'padding',
    value: '5px'
  },
  {
    name: 'verticalAlign',
    value: 'middle'
  },
  {
    name: 'borderWidth',
    value: '1px'
  },
  {
    name: 'borderStyle',
    value: 'solid'
  },
  {
    name: 'borderColor',
    value: '#dddddd'
  },
  {
    name: 'wordBreak',
    value: 'break-all'
  }
]

export default columnsDefaultStyles



// WEBPACK FOOTER //
// ./src/constants/toolbarEditorOptions/columnsDefaultStyles.js